import type { ISortByObjectSorter } from 'fast-sort'
import { sort as fastSort } from 'fast-sort'

export const sort =
  <T>(by: ISortByObjectSorter<T> | ISortByObjectSorter<T>[]) =>
  (array: T[]): T[] =>
    fastSort(array).by(by)
